import { render, staticRenderFns } from "./_trialBalance.vue?vue&type=template&id=dee872da&scoped=true&"
import script from "./_trialBalance.vue?vue&type=script&lang=js&"
export * from "./_trialBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee872da",
  null
  
)

export default component.exports